import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";

type RectangleHandleProps = {
  type?: "target" | "source";
  position?: Position;
  width?: number;
  height?: number;
};

function RectangleHandle({
  type,
  position,
  width,
  height,
}: RectangleHandleProps) {
  // width: 12,
  // height: data.width / 8,
  const handleWidth =
    position === Position.Bottom || position === Position.Top ? width / 8 : 12;
  const handleHeight =
    position === Position.Bottom || position === Position.Top ? 12 : width / 8;
  return (
    <Handle
      type={type ?? "target"}
      position={position ?? Position.Left}
      className={`!bg-teal-500`}
      style={{
        width: handleWidth,
        height: handleHeight,
        borderRadius: 3,
        borderColor: "transparent",
      }}
    />
  );
}

export default memo(RectangleHandle);
